if (!customElements.get('adev-image-carousel')) {
    customElements.define('adev-image-carousel', class adevImageCarousel extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-image-carousel="carousel"]');
        }
        
        initCarousel(){
            let settings = {
                cellAlign: 'left',
                contain: false,
                wrapAround: Shopify.designMode ? true : true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: 0,
                adaptiveHeight: false,
                on: {
                    ready: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                    },
                    settle: () => {
                        this.carouselEl.classList.add('adev--flickity-ready');
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    },
                    dragStart: () => {
                        this.carouselEl.classList.add('adev--flickity-moving');
                    },
                    dragEnd: () => {
                        this.carouselEl.classList.remove('adev--flickity-moving');
                    }
                }
            };

            this.carouselInstance = new Flickity(this.carouselEl, settings);

            window.matchMedia('(min-width: 768px)').addEventListener('change', this.updateOptions.bind(this));
            window.matchMedia('(min-width: 992px)').addEventListener('change', this.updateOptions.bind(this));
            window.matchMedia('(min-width: 1200px)').addEventListener('change', this.updateOptions.bind(this));

            this.updateOptions();
        }

        updateOptions(e){
            const totalItems = this.carouselInstance.cells.length;
            if (totalItems === 0) return;

            const settings = JSON.parse(this.carouselEl.dataset.settings || '{}');

            const columnsPerRowDesktop = settings.itemsPerRowDesktop || 5;
            const columnsPerRowLaptop = settings.itemsPerRowLaptop || 4;
            const columnsPerRowTablet = settings.itemsPerRowTablet || 3;
            const columnsPerRowMobile = settings.itemsPerRowMobile < 100 && settings.itemsPerRowMobile > 50 ? 2 : 1;

            const mediaQueries = [
                { mq: '(min-width: 1200px)', columns: columnsPerRowDesktop },
                { mq: '(min-width: 992px) and (max-width: 1199px)', columns: columnsPerRowLaptop },
                { mq: '(min-width: 768px) and (max-width: 991px)', columns: columnsPerRowTablet },
                { mq: '(max-width: 767px)', columns: columnsPerRowMobile }
            ];

            for (let i = 0; i < mediaQueries.length; i++) {
                const { mq, columns } = mediaQueries[i];
                if (window.matchMedia(mq).matches) {
                    this.carouselInstance.options.draggable = totalItems > columns;
                    this.carouselInstance.updateDraggable();
                    break;
                }
            }
        }

        destroyCarousel(){
            if(this.carouselInstance){
                this.carouselInstance.destroy();
            }
        }

        initShopifyCustomizer(){
            if (!Shopify.designMode) return;

            document.addEventListener('shopify:block:select', (event) => {
                const blockId = event.detail.blockId;
                const blockElement = this.querySelector(`[data-adev-image-carousel="carousel-item"][data-block-id="${blockId}"]`);

                if (blockElement) {
                    const index = parseInt(blockElement.getAttribute('data-index'), 10);
                    this.carouselInstance.select(index);
                }
            });
        }

        connectedCallback() {
            this.initCarousel();
            this.initShopifyCustomizer();
        }

        disconnectedCallback() {
            this.destroyCarousel();
            windo
        }

    });
}